import { render } from "./Contact-index.vue?vue&type=template&id=272a2cfc"
import script from "./Contact-index.vue?vue&type=script&lang=js"
export * from "./Contact-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__